<template>
  <article v-if="$store.getters.menu" id="menu" :class="visible" :style="styleOption">
    <ul>
      <li v-for="item in menuItemList" :key="item.value" @click="onSelected(item)" :class="{hrw: item.line}">
        {{ item.text }}
      </li>
    </ul>
  </article>
</template>

<script>
import {Menu} from '@/components/js/Utils'

export default {
  props: {},
  name: 'umenu',
  watch: {
    '$store.getters.menu': 'open'
  },
  computed: {
    menuItemList () {
      console.log(this.optionType)
      switch (this.optionType) {
        case 'work' :
          if (this.optionMy) {
            if (this.optionDelete) {
              return [
                {text: '삭제취소', value: Menu.DELETE_CANCEL}
              ]
            } else {
              return [
                {text: '이름수정하기', value: Menu.CHANGE_NAME},
                {text: this.optionVisibleText, value: Menu.VISIBLE},
                {text: this.optionMainText, value: Menu.MAINOPEN},
                {line: true},
                {text: '삭제하기', value: Menu.DELETE}
              ]
            }
          } else {
            return [
              {text: '신고하기', value: Menu.REPORT}
            ]
          }
        case 'category' :
          return [
            {text: '이름수정하기', value: Menu.CHANGE_NAME},
            {text: '글쓰기', value: Menu.CREATE_POST},
            {text: '전체 ' + this.optionVisibleText, value: Menu.VISIBLE},
            {text: '전체 ' + this.optionMainText, value: Menu.MAINOPEN},
            {text: '더보기', value: Menu.OPEN_VIEW},
            {line: true},
            {text: '삭제하기', value: Menu.DELETE}
          ]
        case 'buybook' :
          return [
            {text: '구매목록에서 제거', value: Menu.BUY_DELETE},
            {line: true},
            {text: '신고하기', value: Menu.REPORT}
          ]
        case 'buypost' :
          return [
            {text: '신고하기', value: Menu.REPORT}
          ]
        case 'readbook' :
        case 'readpost' :
          return [
            {text: '읽기목록에서 제거', value: Menu.READ_DELETE},
            {line: true},
            {text: '신고하기', value: Menu.REPORT}
          ]
        case 'likebook' :
          return [
            {text: '좋아요 취소', value: Menu.LIKE_DELETE},
            {line: true},
            {text: '신고하기', value: Menu.REPORT}
          ]
        case 'book' :
          if (this.optionMy) {
            return [
              {text: '글쓰기', value: Menu.CREATE_POST},
              {text: this.optionVisibleText, value: Menu.VISIBLE},
              {text: this.optionMainText, value: Menu.MAINOPEN},
              {text: '저작공간이동', value: Menu.MOVE_WORK},
              {text: '카테고리이동', value: Menu.MOVE_CATEGORY},
              {text: '출판신청', value: Menu.PUBLICATION},
              {line: true},
              {text: '삭제하기', value: Menu.DELETE}
            ]
          } else {
            return [
              {text: '읽기목록에 저장', value: Menu.READ},
              {line: true},
              {text: '신고하기', value: Menu.REPORT}
            ]
          }
        case 'infopost' :
          if (this.optionMy) {
            return [
              {text: '수정하기', value: Menu.EDIT},
              {text: this.optionVisibleText, value: Menu.VISIBLE},
              {line: true},
              {text: '삭제하기', value: Menu.DELETE}
            ]
          } else {
            return [
              {text: '읽기목록에 저장', value: Menu.READ},
              {text: '나중에 볼 글에 저장', value: Menu.LATERPOST},
              {line: true},
              {text: '신고하기', value: Menu.REPORT}
            ]
          }
        case 'latelypost' :
          return [
            {text: '읽기목록에 저장', value: Menu.READ},
            // {text: '삭제하기', value: Menu.DELETE},
            {line: true},
            {text: '신고하기', value: Menu.REPORT}
          ]
        case 'laterpost' :
          return [
            {text: '읽기목록에 저장', value: Menu.READ},
            {text: '삭제하기', value: Menu.DELETE},
            {line: true},
            {text: '신고하기', value: Menu.REPORT}
          ]
        case 'comment' :
          console.log(this.menu)
          if (this.optionMy) {
            return [
              {text: '수정하기', value: Menu.EDIT},
              {text: '삭제하기', value: Menu.DELETE}
            ]
          } else {
            console.log(this.menu.param)
            if (this.menu.param.comment.recomment instanceof Array && this.compareMy(this.menu.param.postuser)) {
              return [
                {text: '답글쓰기', value: Menu.RECOMMENT},
                {text: '신고하기', value: Menu.REPORT}
              ]
            } else {
              return [
                {text: '신고하기', value: Menu.REPORT}
              ]
            }
          }
        case 'admin-contract-apply':
          return [
            {text: '승인취소', value: Menu.CANCEL},
            {text: '계약완료', value: Menu.COMPLETE}
          ]
        case 'admin-contract-complete':
          return [
            {text: '계약종료', value: Menu.COMPLETE},
            {text: '계약취소', value: Menu.CANCEL}
          ]
        case 'admin-publishing-apply':
          return [
            {text: '승인취소', value: Menu.CANCEL},
            {text: '판매시작', value: Menu.COMPLETE}
          ]
        case 'admin-withdrawal-apply':
          return [
            {text: '승인', value: Menu.COMPLETE},
            {text: '취소', value: Menu.CANCEL}
          ]
      }
    },
    menu () {
      return this.$store.getters.menu
    },
    styleOption () {
      if (this.menu) {
        this.$root.$el.addEventListener('mouseup', this.mouseUp)
        var ys = this.menuItemList.length * 30 + this.menu.h
        console.log(window.innerWidth, window.innerHeight, {
          left: Math.min(this.menu.x, window.innerWidth - 175) + 'px',
          top: ((this.menu.y + ys > window.innerHeight) ? this.menu.y - ys - 20 : this.menu.y) + 'px'
        })
        return {
          left: Math.min(this.menu.x, window.innerWidth - 175) + 'px',
          top: ((this.menu.y + ys > window.innerHeight) ? this.menu.y - ys - 20 : this.menu.y) + 'px'
        }
      } else {
        return {
          left: '0px',
          top: '0px'
        }
      }
    },
    visible () {
      return (this.menu) ? 'show' : 'hide'
    },
    optionType () {
      return (this.menu) ? this.menu.type : ''
    },
    optionMy () {
      return (this.menu) ? this.menu.my : false
    },
    optionVisible () {
      return (this.menu) ? Boolean(this.menu.visible) : false
    },
    optionMain () {
      return (this.menu) ? Boolean(this.menu.mainopen) : false
    },
    optionDelete () {
      return (this.menu) ? this.menu.delete : false
    },
    optionVisibleText () {
      return (this.optionVisible) ? '공개하기' : '비공개하기'
    },
    optionMainText () {
      return (this.optionMain) ? '메인노출함' : '메인노출안함'
    }
  },
  methods: {
    open () {
    },
    onSelected: function (e) {
      console.log('onSelected', e)
      if (this.menu.callback != null) {
        e.param = this.menu.param
        this.menu.callback(e)
      }
      this.$store.dispatch('closeMenu')
    },
    mouseUp: function (e) {
      if (!this.isTarget(e, this.$el)) {
        this.$store.dispatch('closeMenu')
      }
      this.$root.$el.removeEventListener('mouseup', this.mouseUp)
    }
  },
  components: {
    'menuItem': {
      props: {
        param: {
          type: String
        },
        text: {
          type: String
        }
      },
      template: '<li @click="$parent.onSelected(param)">{{text}}</li>'
    },
    'menuVisibleItem': {
      props: {
        visible: {
          type: Boolean,
          required: true
        },
        param: {
          type: String
        }
      },
      template: '<menuItem v-if="visible === true" :param="param" text="비공개하기"/><menuItem v-else :param="param" text="공개하기"/>'
    },
    'menuLineItem': {
      template: '<li class="hrw"></li>'
    }
  }
}
</script>

<style scoped>
#menu {
  min-width: 165px;
  width: 165px;
  position: absolute;
  border: 1px solid #CCCCCC;
  background-color: var(--bg-white);
  color: #999999;
  z-index: 10;
  font-size: 14px;
  margin-top: 5px;
}
#menu > ul {
  width: 100%;
  list-style: none;
  margin: 5px 0px;
  text-align: left;
  flex-direction: column;
  padding: 0px;
}
#menu > ul > div {
  width: 100%;
  text-align: left;
  flex-direction: column;
}
#menu > ul li {
  height: 30px;
  cursor: default;
  display: flex;
  align-items: center;
  padding: 0px 15px;
}
#menu > ul li:hover {
  color: #00B0FF;
}
#menu .hrw {
  width:100%;
  height: 1px;
  border-top: 1px solid #DDDDDD;
  margin: 5px 0px 5px 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/ui/Umenu.vue